import type { FC, ReactNode } from "react";
import { Fragment } from "react";
import List from "@mui/material/List";
import { MenuItem } from "../../molecules/MenuItem/MenuItem";
import { Box, Button, Divider, Stack } from "@mui/material";
import { useRouterState } from "@tanstack/react-router";

export type MainMenuProps = {
    items?: { text: ReactNode; href: string; icon: ReactNode }[][];
    actionButton?: {
        text: string;
        icon?: ReactNode;
        onClick: () => void;
    };
};

export const MainMenu: FC<MainMenuProps> = ({
    items: groups = [],
    actionButton,
}) => {
    const router = useRouterState();
    const pathname = router?.location?.pathname || "";

    const isActive = (href: string) => {
        if (!pathname) return false;

        if (pathname === href) return true;

        if (pathname.startsWith(href)) {
            const nextChar = pathname[href.length];
            return !nextChar || nextChar === "/";
        }

        return false;
    };

    return (
        <Stack
            direction="column"
            justifyContent="space-between"
            sx={{ height: "calc(100vh - 64px)" }}
        >
            <List color="inherit">
                {groups.map((items) =>
                    items.map((item, index) => (
                        <Fragment key={index}>
                            <MenuItem
                                key={index}
                                href={item.href}
                                icon={item.icon}
                                text={item.text}
                                active={isActive(item.href)}
                            />
                            {index !== items.length - 1 ? (
                                <Divider sx={{ mt: 2, mb: 2 }} />
                            ) : null}
                        </Fragment>
                    ))
                )}
            </List>
            {actionButton ? (
                <Box
                    sx={{
                        width: "100%",
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Button
                        onClick={actionButton.onClick}
                        variant="text"
                        color="primary"
                        startIcon={actionButton.icon}
                        sx={{ mb: 0, mt: "auto", justifyContent: "flex-start" }}
                    >
                        {actionButton.text}
                    </Button>
                </Box>
            ) : null}
        </Stack>
    );
};
